import { useEffect } from "react";
import { usePdbData } from "../../hooks/app/usePdbData";
import { useWebLinkData } from "../../hooks/useWebLinkData";

const PdbData = () => {
  const { isPdbDataLoaded, loadPdbData } = usePdbData();
  const { isWebLinkLoaded, loadWebLinkData } = useWebLinkData();

  useEffect(() => {
    if (!isPdbDataLoaded) {
      loadPdbData();
    }
  }, [isPdbDataLoaded, loadPdbData]);

  useEffect(() => {
    if (!isWebLinkLoaded) {
      loadWebLinkData();
    }
  }, [isWebLinkLoaded, loadWebLinkData]);

  return <></>;
};

export default PdbData;
